import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LOAD_PERMISSIONS } from "../../store/permissions/types";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";

import { Container, Row, Col, CardBody, Card, Form, FormFeedback, Input } from "reactstrap";

// import images
import logo from "../../assets/images/logo-sm.png";

const LockScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [error, setError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const token = localStorage.getItem('authToken');
  const version = localStorage.getItem("app_version");

  const permissionMap = useSelector(
    state => state.permissions?.permissions
  );

  useEffect(() => {
    if (loginSuccess && permissionMap && Object.keys(permissionMap).length > 0) {
      navigate("/dashboard", { replace: true });
    }
  }, [loginSuccess, permissionMap]);

  useEffect(() => {
    const u = localStorage.getItem("authUser");
    if (u) {
      setUser(JSON.parse(u));
    }
  }, []);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      password: '',
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Please Enter Password"),
    }),
    onSubmit: async (values) => {
      try {
        const loginResponse = await fetch("https://api.kunalsdrumclass.com/api/Login", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            emailAddress: user.Email_Address,
            password: values.password
          })
        });

        if (!loginResponse.ok) {
          setError("Invalid Username or Password");
          return;
        }

        const result = await loginResponse.json();
        const userData = result?.recordsets?.[0] || [];
        const usersData = result?.recordsets?.[0] || [];
        if (result?.recordsets?.[0]?.[0]?.Status === 0) {
          setError("Please check your credencials!");
          return; 
        } else if (result?.recordsets?.[0]?.[0]?.Status === -1) {
          setError("Not allowed to login. Please contact admin.");
          return; 
        } else if (result?.recordsets?.[0]?.[0]?.Status === -2) {
          setError("Student is in-active. Please contact admin.");
          return; 
        } else if (result?.recordsets?.[0]?.[0]?.Status === -3) {
          setError("Student is pending for approval. Please contact admin.");
          return; 
        } else if (result?.recordsets?.[0]?.[0]?.Status === -4) {
          setError("Student is not approved. Please contact admin.");
          return; 
        } else if (result?.recordsets?.[0]?.[0]?.Status === 1) {
          dispatch({ type: LOAD_PERMISSIONS });
          setLoginSuccess(true);
        }
      } catch (err) {
        console.error(err);
        setError("Something went wrong! Check server.");
      }
    }
  });
  document.title = "Lock Screen | KDC - Kunal's Drum Class";
  return (
    <React.Fragment>
      <div className="account-pages login-page pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md="8" lg="6" xl="4">
              <Card className="forgot-side overflow-hidden">
                <div className="">
                  <div className="text-primary text-center p-4">
                    <h3 className="text-white">Locked</h3>
                    <p className="text-white">
                      Hello {user?.Name || "User"}, enter your password to unlock the screen!
                    </p>
                    <Link to="/dashboard" className="logo logo-admin">
                      <img src={logo} height="40" alt="logo" />
                    </Link>
                  </div>
                </div>
                <CardBody className="p-4">
                  <div className="p-3">
                    <Form className="mt-4"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                      action="#">

                      <div className="pt-3 text-center">
                        <img src={user?.ImageURL ? user?.ImageURL : 'https://res.cloudinary.com/dzbakfw3i/image/upload/v1770116479/profile.png'} className="rounded-circle img-thumbnail avatar-lg" alt="thumbnail" />
                        <h6 className="font-size-16 text-white mt-3">{user?.Name || "User"}</h6>
                      </div>

                      <div className="mb-3">
                        <label className="form-label" htmlFor="userpassword">Password*</label>
                        <div className="input-group">
                          <Input
                            name="password"
                            className="form-control"
                            placeholder="Enter password"
                            type={showPassword ? "text" : "password"}
                            id="password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          <span
                            className="input-group-text"
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            <i className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                          </span>

                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                          ) : null}
                        </div>
                      </div>
                      {error && <p className="text-danger">{error}</p>}
                      <div className="row mb-0">
                        <div className="col-12 text-end">
                          <button className="btn btn-primary w-md waves-effect waves-light" type="submit">Unlock</button>
                        </div>
                      </div>

                    </Form>

                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p className="text-white">
                  Not you? return{" "}
                  <Link
                    to="/login"
                    className="fw-medium text-white"
                  >
                    {" "}
                    Sign In{" "}
                  </Link>{" "}
                </p>
                <p className="text-white">
                  KDC © {new Date().getFullYear()} | Version: {version} <br/> Developed By <a href="https://www.thebridgecode.com/" className="text-primary">The Bridge Code</a>.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default LockScreen;
